import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectsService {

  constructor( private http: HttpClient) { }
  getAllProject(empEmail: String, pageNo: Number,fromDate:string,toDate:string,status:string): Observable<any> {
    let obj = {
      'email': empEmail,
      'pageNo': pageNo.toString(),
      'fromDate':fromDate,
      'toDate' :toDate,
      'status':status
    }
    return this.http.post('contripoint/project/byYear', obj);

  }
  createProject(createInterviewRequestBody: any) {
    return this.http.post<any>('contripoint/project/add', createInterviewRequestBody);
  }
  saveAsDraft(createInterviewRequestBody: any) {
    return this.http.post<any>('contripoint/project/drafts', createInterviewRequestBody);
  }
  getSelectedProjectView(projectId: number) {
    let reqParam=new HttpParams().set('projectId',projectId);
     return this.http.get<any>('contripoint/project/view', {'params':reqParam});
    }
    deleteproject(projectId:Number){
      return this.http.delete<any>('contripoint/project/delete/'+projectId);
    }
}
